export default {
  props: {
    id: String
  },
  data () {
    return {
      item: {}
    }
  },
  created () {
    if(this.id) {
      this.preload()
      this.loadData()
    }
  },
  methods: {
    preload () {},
    async loadData() {
      let res = await this.$apix.get(`collections/newtalent/${this.id}`)
      this.item = res.data
    }
  }
}